import { Pipe, PipeTransform } from '@angular/core';
import { toArray, isObject } from '../utils/utils';

@Pipe({
  name: 'toArray'
})
export class ToArrayPipe implements PipeTransform {
  transform(collection: any, addKey: boolean = false): any {

    if (!isObject(collection)) {
      return collection;
    }

    return addKey
      ? Object.keys(collection).map((key: string) => {
        // TODO: object.assign polyfill
        let o = collection[key];
        o.$key = key;
        return o;
      })
      : toArray(collection);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/collection/to-array.pipe.ts